/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Section } from 'ui/molecules/Section/Section';

import { CategorySidebar } from 'landing-pages/data-dictionary/sections/CategorySidebar/CategorySidebar';
import { CategoryTable } from 'landing-pages/data-dictionary/sections/CategoryTable/CategoryTable';

import styles from './DataDictionaryCatalog.module.scss';

import {
  CREDIT_FIELDS,
  CREDIT_ICON,
  DIGITAL_FIELDS,
  DIGITAL_ICON,
  EXEC_FIELDS,
  EXEC_ICON,
  FINANCIAL_FIELDS,
  FINANCIAL_ICON,
  FIRMO_FIELDS,
  FIRMO_ICON,
  getCategories,
  getTotalFieldsLabel,
  GROUP_FIELDS,
  GROUP_ICON,
  INVESTMENT_FIELDS,
  INVESTMENT_ICON,
  OFFICERS_FIELDS,
  OFFICERS_ICON,
  REGISTRY_FIELDS,
  REGISTRY_ICON,
  SHARE_FIELDS,
  SHARE_ICON,
} from './DataDictionaryCatalog.data';

export const DataDictionaryCatalog = () => {
  const { t } = useInt();

  return (
    <Section className={styles.root}>
      <div className={styles.grid}>
        <CategorySidebar items={getCategories(t)} totalLabel={getTotalFieldsLabel(t)} />

        <div className={styles.body}>
          <CategoryTable
            id="p-registry"
            title={t('Company Registry Data')}
            count={18}
            color="blue"
            icon={REGISTRY_ICON}
            fields={REGISTRY_FIELDS}
          />
          <CategoryTable
            id="p-officers"
            title={t('Officers & Directors')}
            count={12}
            color="cyan"
            icon={OFFICERS_ICON}
            fields={OFFICERS_FIELDS}
          />
          <CategoryTable
            id="p-financial"
            title={t('Financial Data')}
            count={49}
            color="green"
            icon={FINANCIAL_ICON}
            fields={FINANCIAL_FIELDS}
          />
          <CategoryTable
            id="p-group"
            title={t('Group Structure (Company Linkages)')}
            count={24}
            color="purple"
            icon={GROUP_ICON}
            fields={GROUP_FIELDS}
          />
          <CategoryTable
            id="p-share"
            title={t('Shareholders')}
            count={13}
            color="pink"
            icon={SHARE_ICON}
            fields={SHARE_FIELDS}
          />
          <CategoryTable
            id="p-credit"
            title={t('Credit Risk')}
            count={10}
            color="red"
            icon={CREDIT_ICON}
            fields={CREDIT_FIELDS}
          />
          <CategoryTable
            id="p-firmo"
            title={t('Firmographic Data')}
            count={23}
            color="amber"
            icon={FIRMO_ICON}
            fields={FIRMO_FIELDS}
          />
          <CategoryTable
            id="p-investment"
            title={t('M&A Activity')}
            count={32}
            color="blue"
            icon={INVESTMENT_ICON}
            fields={INVESTMENT_FIELDS}
          />
          <CategoryTable
            id="p-exec"
            title={t('Key Executives')}
            count={11}
            color="slate"
            icon={EXEC_ICON}
            fields={EXEC_FIELDS}
          />
          <CategoryTable
            id="p-digital"
            title={t('Digital Insights')}
            count={10}
            color="cyan"
            icon={DIGITAL_ICON}
            fields={DIGITAL_FIELDS}
          />
        </div>
      </div>
    </Section>
  );
};
